'use client';

import { PolicyPage } from 'components/organisms/PolicyPage';

const PrivacyPage = () => <PolicyPage id="b4642812-b2b4-4a66-b691-6f71e6d0d29f" />;

export default PrivacyPage;
